import { addRefreshAuthToDataProvider } from 'react-admin'
import {refreshAuth} from "./authProvider";
import GennevApiService, {paginationToParamsConverter} from "../services/gennev-api.service";

export const UserDataProvider = addRefreshAuthToDataProvider(() => ({
    getList: async (resource, params) => {
        const {sort, range} = paginationToParamsConverter(params);
        const {users, total} = await GennevApiService.getFilteredUsers({
            filter:params.filter,
            sort,
            range,
        })
        return {data: users, total}
    },
    getOne: async (resource, params) => {
        if (!params.id || params.id === 'undefined') {
            return {data: null};
        }
        const {user} = await GennevApiService.getUser(params.id)
        return {data: user}
    },
    create: async (resource, params) => {
        const {user} = await GennevApiService.createUser(params.data)
        return {data: user}
    },
    update: async (resource, params) => {
        const {user} = await GennevApiService.updateUser(params.id, params.data)
        return {data: user}
    },
    delete: async (resource, params) => {
        await GennevApiService.deleteUser(params.id)
        return {data: params.id}
    },
    getMany: async (resource, params) => {
        const filterBy = params.meta?.fieldName || 'id'
        const {users, total} = await GennevApiService.getFilteredUsers({
            filter:{[filterBy]:params.ids},
        })
        return {data: users, total}
    },
    getManyReference: (resource, params) => {
        console.log(resource, params);
    },
        // simple-rest doesn't handle provide an updateMany route, so we fall back to calling update n times instead
    updateMany: (resource, params) =>
        Promise.all(
            params.ids.map(async id => {
                const {user} = await GennevApiService.updateUser(params.data.id, params.data)
                return {data: user}
            })
        ).then(responses => ({data: responses.map(({json}) => json.id)})),
    // simple-rest doesn't handle filters on DELETE route, so we fallback to calling DELETE n times instead
    deleteMany: (resource, params) =>
        Promise.all(
            params.ids.map(async id =>
                await GennevApiService.deleteUser(id)
            )
        ).then(responses => ({
            data: responses.map(({json}) => json.name),
        })),
}), refreshAuth);
